<template>
  <el-header class="w-full h-15 bg-[#222637] shadow">
    <div class="flex items-center justify-between h-full">
      <div class="flex items-center text-white">
        <div
          @click="handleMenuCollapse"
          class="w-4 h-4 bg-[url(@/assets/images/icon_menu.png)] bg-no-repeat bg-cover cursor-pointer mr-4"
        ></div>
        <div class="flex items-center text-sm">
          <el-icon size="20" class="mr-2">
            <component :is="breadcrumb[0]?.icon"></component>
          </el-icon>
          <el-breadcrumb separator="|">
            <el-breadcrumb-item class="text-white!" v-for="item in breadcrumb" :key="item.path">{{
              item.title
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <el-dropdown class="">
        <div class="cursor-pointer text-white flex items-center">
          <!-- <el-avatar size="small" class="mr-2" src="/src/assets/images/avatar.jpg" /> -->
          <el-icon class="mr-2" size="16"><User /></el-icon>
          {{ userName }}
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item>
              <div class="flex cursor-pointer" @click="handleChangePwd">
                <div
                  class="bg-[url(@/assets/images/pwd.png)] bg-no-repeat bg-size-[18px] bg-center w-6 mr-1"
                ></div>
                <div class="flex-1">修改密码</div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided @click="logout">
              <div class="flex cursor-pointer">
                <div
                  class="bg-[url(@/assets/images/exit.png)] bg-no-repeat bg-size-[18px] bg-center w-6 mr-1"
                ></div>
                <div class="flex-1">退出登录</div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-header>

  <!--修改密码-->
  <UpdatePwd v-model="visible" :isForce="isForce" :msg="tipmsg"></UpdatePwd>
</template>

<script lang="ts" setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/index'
import UpdatePwd from '@/components/UpdatePwd.vue'
import emitter from '@/utils/eventBus'
import { find } from 'lodash-es'
import { verifyPwd } from '@/api/user/index'

const router = useRouter()
const storeUserInfo = useUserStore()

const userName = ref('')
const visible = ref(false)
const menuArray = ref()
const breadcrumb = ref<{ icon: string; title: string; path: string }[]>([
  {
    icon: 'House',
    path: '/index',
    title: '首页',
  },
])

onMounted(() => {
  onVerifyPwd()
  userName.value = storeUserInfo.userName
  menuArray.value = storeUserInfo.userRoleFlat

  if (storeUserInfo.nowMenu) {
    handleBreadcrumb(storeUserInfo.nowMenu)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emitter.on('mittActiveMenu', (keyPath: any) => {
    handleBreadcrumb(keyPath)
  })
})

const isForce = ref(false)
const tipmsg = ref('')

const onVerifyPwd = () => {
  verifyPwd().then((res) => {
    isForce.value = !res.data.data
    if (isForce.value) {
      visible.value = true
      tipmsg.value = res.data.msg
    }
  })
}

//处理面包屑显示逻辑
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleBreadcrumb = (keyPath: any) => {
  breadcrumb.value = []
  if (keyPath[0] == '/index' || keyPath.length == 0) {
    breadcrumb.value.push({
      icon: 'House',
      path: '/index',
      title: '首页',
    })
  } else {
    keyPath.forEach((e: string) => {
      const thatMenu = find(menuArray.value, ['path', e])
      if (thatMenu) {
        breadcrumb.value.push({
          icon: thatMenu.icon,
          title: thatMenu.name,
          path: thatMenu.path,
        })
      }
    })
  }
}

const logout = () => {
  ElMessageBox.confirm('是否确认退出?', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '关闭',
    closeOnClickModal: false,
    autofocus: true,
    type: 'warning',
  })
    .then(() => {
      localStorage.removeItem('token')
      ElMessage.success('退出登录成功')
      router.push('/login')
    })
    .catch(() => {
      // catch error
    })
}

//重置密码弹窗
const handleChangePwd = () => {
  visible.value = true
}

//显示或者隐藏菜单栏
const isCollapse = ref(false)
const handleMenuCollapse = () => {
  isCollapse.value = !isCollapse.value
  // emitter.emit('mittCollapse', isCollapse.value)
}
</script>

<style lang="less" scoped>
:deep(.el-breadcrumb__inner) {
  color: #fff !important;
}

.dialog-footer {
  text-align: center;
}
</style>
